import type { MenuItem } from "../../designSystem/components/navigation/Menu";
import { useToast } from "../../designSystem";
import { useCompanyContext } from "../../components/companies/useCompanyContext";
import { canShowEmbeddedWalletMenu } from "../nonCustodial/canShowEmbeddedWalletMenu";
import { getBusinessIdentityContext } from "./businessIdentityContext";
import { walletConnectFailureTitle, walletDisconnectFailureTitle } from "./embeddedWalletConfig";
import { useEmbeddedWalletSession } from "./embeddedWalletSession";
import { formatWalletAddress } from "../formatWalletAddress";

export { formatWalletAddress };

export const useEmbeddedWalletMenuItems = (): MenuItem[] => {
  const { features, companyId, userCompanyRoles } = useCompanyContext();
  const { userCompanyRoles: activeRoles } = getBusinessIdentityContext({ companyId, userCompanyRoles });
  const { addresses, disconnect, showAuthFlow } = useEmbeddedWalletSession();
  const { enqueue } = useToast();

  if (!canShowEmbeddedWalletMenu(features, activeRoles)) {
    return [];
  }

  if (addresses.length === 0) {
    return [
      {
        id: "login-wallet",
        label: "Login wallet",
        testId: "user-menu-login-wallet",
        onSelect: () => {
          try {
            showAuthFlow();
          } catch (error) {
            const cancelled = error instanceof Error && error.name === "WalletConnectCancelledError";
            enqueue({
              tone: "error",
              title: cancelled ? walletConnectFailureTitle("user-cancelled") : walletConnectFailureTitle({ error }),
            });
          }
        },
      },
    ];
  }

  return [
    {
      id: "logout-wallet",
      label: "Logout wallet",
      testId: "user-menu-logout-wallet",
      onSelect: () => {
        disconnect().catch((error) => {
          console.error("Embedded wallet disconnect failed:", error);
          enqueue({
            tone: "error",
            title: walletDisconnectFailureTitle(),
          });
        });
      },
    },
    ...addresses.map((address) => ({
      id: `wallet-address-${address}`,
      label: formatWalletAddress(address),
      testId: "user-menu-wallet-address",
      disabled: true,
      className: "u-font-mono",
    })),
  ];
};
